import React from "react";
import { Hero } from "./components/Hero";
import { OfferBar } from "./components/OfferBar";
import { TrustStrip } from "./components/TrustStrip";
import { ProblemsSection } from "./components/ProblemsSection";
import { SolutionSection } from "./components/SolutionSection";
import { BookSection } from "./components/BookSection";
import { SamplesCarousel } from "./components/SamplesCarousel";
import { OfferDetails } from "./components/OfferDetails";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { FaqSection } from "./components/FaqSection";
import { ClosingSection } from "./components/ClosingSection";
import { SiteFooter } from "./components/SiteFooter";
import { StickyOfferBar } from "./components/StickyOfferBar";
export function App() {
  return <main className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="28u5z6q8t7bef">
      <Hero data-id="element-1" data-mp="28s2ztflro5x1" />
      <OfferBar data-id="element-2" data-mp="23vkwmk634fmt" />
      <TrustStrip data-id="element-3" data-mp="23vulg4fe8gqx" />
      <ProblemsSection data-id="element-4" data-mp="23ujksdh8vp41" />
      <SolutionSection data-id="element-5" data-mp="23v2tr4ox335x" />
      <BookSection data-id="element-6" data-mp="3ijxq4swlw4ky" />
      <SamplesCarousel data-id="element-7" data-mp="3ikha0f5th31m" />
      <OfferDetails data-id="element-8" data-mp="3ij652c0mxp8x" />
      <GuaranteeSection data-id="element-9" data-mp="3ijpc2xoqyt86" />
      <FaqSection data-id="element-10" data-mp="3mlja0y7k5j4n" />
      <ClosingSection data-id="element-11" data-mp="3ml14faz09sk2" />
      <SiteFooter data-id="element-12" data-mp="3mkho1yp07c85" />
      <StickyOfferBar data-id="element-13" data-mp="3mjztd6hzp62c" />
    </main>;
}